import { render, staticRenderFns } from "./AstaRosa.vue?vue&type=template&id=56d622ee&scoped=true&"
import script from "./AstaRosa.vue?vue&type=script&lang=js&"
export * from "./AstaRosa.vue?vue&type=script&lang=js&"
import style0 from "./AstaRosa.vue?vue&type=style&index=0&id=56d622ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d622ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d622ee')) {
      api.createRecord('56d622ee', component.options)
    } else {
      api.reload('56d622ee', component.options)
    }
    module.hot.accept("./AstaRosa.vue?vue&type=template&id=56d622ee&scoped=true&", function () {
      api.rerender('56d622ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AstaRosa.vue"
export default component.exports